import { render, staticRenderFns } from "./KurccSiteBranchesPage.vue?vue&type=template&id=0924272f&"
import script from "./KurccSiteBranchesPage.vue?vue&type=script&lang=js&"
export * from "./KurccSiteBranchesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports